module.exports = __webpack_public_path__ + "media/images/homepage_images/cover_2-2803bfddb4b725d15238c0d679a9c6af.jpeg";